const ExitPopup = ({
    showExitPopup,
    handleSaveToDraft,
    handleCancel,
    handleExitWithoutSaving
}) => {
    if (!showExitPopup) return null;

    return (
        <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg px-4 py-6 mx-4 w-full max-w-sm">
                <h3 className="text-[14px] font-semibold text-gray-900 mb-4 text-center">
                    Are you sure you want to exit?
                </h3>
                <div className="flex items-center space-x-3">
                    <button
                        onClick={handleCancel}
                        className="w-full text-[12px] whitespace-nowrap py-1 px-2 bg-[#e22828] text-white border border-black rounded font-semibold"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={handleExitWithoutSaving}
                        className="w-full text-[12px] whitespace-nowrap py-1 px-2 bg-[#BDE6FF] text-black border border-black rounded font-semibold"
                    >
                        Exit without saving
                    </button>
                    <button
                        onClick={handleSaveToDraft}
                        className="w-full text-[12px] whitespace-nowrap py-1 px-2 bg-[#BDE6FF] text-black border border-black rounded font-semibold"
                    >
                        Save to Drafts
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ExitPopup;